import { render, staticRenderFns } from "./CollapsibleHeader.vue?vue&type=template&id=651e95a8&"
import script from "./CollapsibleHeader.vue?vue&type=script&lang=ts&"
export * from "./CollapsibleHeader.vue?vue&type=script&lang=ts&"
import style0 from "./CollapsibleHeader.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports